// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M1460.4735,824.776833 L1459,830 L1464.22317,828.5265 L1470.07692,822.67275 L1466.32725,818.923083 L1460.4735,824.776833 Z M1472.223,816.777 C1471.7225,816.275917 1471.05633,816 1470.34817,816 C1469.64,816 1468.97383,816.275917 1468.47333,816.777 L1467.15383,818.0965 L1470.9035,821.846167 L1472.223,820.526667 C1472.72408,820.026167 1473,819.36 1473,818.651833 C1473,817.943083 1472.72408,817.2775 1472.223,816.777 Z", transform: "translate(-1459 -816)" })))));
};
Icon.displayName = 'Pencil14x14';
export default Icon;
//# sourceMappingURL=Pencil14x14.js.map